import React from "react";
import { useTranslation } from "react-i18next";

// common
import Modal, { ModalText, ModalLayout, MoreModalButtons } from "common/modal";

const { ConfirmationText } = ModalText;
const { ModalRow } = ModalLayout;
const { ModalButtonYellow, ButtonContainer } = MoreModalButtons;

type TProps = {
  visible: boolean;
  onCloseModal: () => void;
};

const PastClassModal = ({ visible, onCloseModal }: TProps) => {
  const { t } = useTranslation("book_a_class");

  return (
    <Modal
      title={t("PAST CLASS")}
      centered
      visible={visible}
      footer={null}
      onCancel={onCloseModal}
    >
      <ConfirmationText>
        {t(
          "This class already started or took place in the past. You cannot book it anymore."
        )}
      </ConfirmationText>
      <ModalRow>
        <ButtonContainer xs={18}>
          <ModalButtonYellow type="primary" onClick={() => onCloseModal()}>
            {t("OKAY")}
          </ModalButtonYellow>
        </ButtonContainer>
      </ModalRow>
    </Modal>
  );
};

export default PastClassModal;
